module.exports = __webpack_public_path__ + "img/body-2-lg.e307a70a.png";